(function($) {
    
    function getReviewData() {
        let reviewData = {};
        const fieldMap = {
            // Popup Form Fields -> HubSpot Properties
            "First Name": "firstname",
            "Name": "firstname",
            "Phone": "phone",
            "Email": "email",
            "Message": "message",
            // Custom
            "Products": "products_name",
            "Cart Products": "products_name",
            // Attribution Fields
            "utm_source": "utm_source",
            "utm_medium": "utm_medium",
            "utm_campaign": "utm_campaign",
            "utm_term": "utm_term",
            "hsa_acc": "hsa_acc",
            "hsa_cam": "hsa_cam",
            "hsa_grp": "hsa_grp",
            "hsa_ad": "hsa_ad",
            "hsa_src": "hsa_src",
            "hsa_tgt": "hsa_tgt",
            "hsa_kw": "hsa_kw",
            "hsa_mt": "hsa_mt",
            "hsa_net": "hsa_net",
            "hsa_ver": "hsa_ver",
            "gclid": "gclid"
        };
        if (!$('#rfq_popup_form').length) {
            console.log('Popup not found');
            return;
        }
        // ==========================
        // Popup Form Data
        // ==========================
        $('.grfq__popupForm__formGroup').each(function() {
            let label = $(this).find('.grfq__popupForm__formLabel label').text().trim();
            let value = $(this).find('.grfq__popupForm__formValue').text().trim();
            if (!value) {
                value = $(this).text().replace(label, '').trim();
            }
            if (fieldMap[label] && value) {
                reviewData[fieldMap[label]] = value;
            }
        });
        // ==========================
        // Attribution Data
        // ==========================
        let savedQuery = sessionStorage.getItem('savedQueryString') || window.location.search;
        let urlParams = new URLSearchParams(savedQuery);
        Object.keys(fieldMap).forEach(function(key) {
            // Only process attribution fields
            if (key.startsWith('utm_') || key.startsWith('hsa_') || key === 'gclid') {
                let value = urlParams.get(key);
                if (value) {
                    reviewData[fieldMap[key]] = value;
                }
            }
        });
        // ==========================
        // Extra HubSpot Tracking
        // ==========================
        let hubspotCookie = document.cookie.match(/hubspotutk=([^;]+)/);
        if (hubspotCookie) {
            reviewData.hubspotutk = hubspotCookie[1];
        }
        reviewData.page_url = window.location.href;
        reviewData.page_name = document.title;

        // ==========================
        // HubSpot Payload
        // ==========================
        let hubspotPayload = {
            fields: Object.keys(reviewData)
                .filter(function(key) {
                    // Don't send context fields inside fields array
                    return key !== 'hubspotutk' && key !== 'page_url' && key !== 'page_name';
                })
                .map(function(key) {
                    return {
                        name: key,
                        value: reviewData[key]
                    };
                }),
            context: {
                hutk: reviewData.hubspotutk || "",
                pageUri: reviewData.page_url || window.location.href,
                pageName: reviewData.page_name || document.title
            }
        };
        // console.log("Final Review Data:", reviewData);
        // console.log("HubSpot Payload:", JSON.stringify(hubspotPayload, null, 2));
        return hubspotPayload;
    }

    // Capture UTM and restore
    const params = new URLSearchParams(window.location.search);
    if (params.has('utm_source')) {
        sessionStorage.setItem('savedQueryString', window.location.search);
    }
    const savedQuery = sessionStorage.getItem('savedQueryString');
    if (savedQuery && !window.location.search) {
        history.replaceState({}, '', window.location.pathname + savedQuery + window.location.hash);
    }

    function getParam(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name) || "";
    }
    // Wait for RFQ popup
    let timer = setInterval(function() {
        if ($('#rfq_popup_form').length && $('.grfq__popupForm__step[data-active="true"]').length) {
            clearInterval(timer);
            $(document).on('click', '.grfq__popupForm__buttonPrimary', function() {
                setTimeout(function() {

                     // Run again after moving to Step 3
                    let activeStep = $('.grfq__popupForm__step[data-active="true"] .grfq__popupForm__stepLabel').text().trim();

                    if (activeStep == '3') {

                        let payload = getReviewData();
                        // console.log(payload);

                        //API Call
                        $.ajax({
                            url: 'https://api.hsforms.com/submissions/v3/integration/submit/23750460/9ad64c67-a30c-4cd0-992c-6887ac3da39d',
                            type: 'POST',
                            contentType: 'application/json',
                            data: JSON.stringify(payload),
                            success: function(response) {
                                console.log('HubSpot Success:', response);
                            },
                            error: function(xhr) {
                                console.log('HubSpot Error:', xhr.responseText);
                            }
                        });
                    }

                }, 500);
            });
        }
    }, 500);
})(jQuery);